export const roomsSelector = state => state.rooms

export const getRoom = (state, id) => roomsSelector(state)[id]


// WEBPACK FOOTER //
// ./src/redux/selectors/objectSelectors.js